import React from 'react';
import styled, { css } from 'react-emotion';
import UIMaxWidth from '../Layout/MaxWidth';
import { LoadingLine } from '@jetshop/ui/Loading/LoadingLine';
import theme from '@jetshop/ui/utils/theme';

const Header = styled('h1')`
  font-family: ${theme('fonts.secondary')};
  font-size: 26px;
  font-weight: 600;
  margin: auto;
  margin-top: 3rem;
  margin-bottom: 1rem;
  text-align: center;
  ${theme('below.md')} {
    margin-top: 1rem;
    margin-bottom: 0.5rem;
  }
`;

const Content = styled('div')`
font-size: 14px;
  margin: 0 auto;

  h2 {
    color: ${theme('colors.primary')};
    font-size: 22px;
    font-weight: bold;
    text-transform: none;
  }

  h3{
    color: ${theme('colors.primary')};
    font-size: 18px;
    text-transform: none;
  }

  p {
    margin-bottom: 1rem;
  }

  a {
    color: ${theme('colors.primary')};
    text-decoration: none;
    transition: ease 0.3s;
    :hover {
      color: ${theme('colors.primaryHover')};
    }
  }

  img,
  p > img {
    display: block;
    margin: auto;
    max-width: 100%;
¨  }

  iframe {
    display: block;
    margin: auto;
    max-width: 100%;
  }
`;

const MaxWidth = styled(UIMaxWidth)`
  max-width: 60rem;
`;

function ContentPage(props) {
  const { result, cacheHit } = props;

  return (
    <>
      <Header>
        <MaxWidth>
          {cacheHit ? (
            result.data.route.object.name
          ) : (
            <LoadingLine heightPx={27} widthRem={15} />
          )}
        </MaxWidth>
      </Header>
      <MaxWidth>
        {cacheHit ? (
          <>
            <Content
              dangerouslySetInnerHTML={{
                __html: result.data.route.object.content
              }}
            />
          </>
        ) : (
          <LoadingLine
            heightPx={14}
            widthRem={30}
            randomizeWidthBy={10}
            count={10}
            className={css`
              margin-bottom: 12px;
            `}
          />
        )}
      </MaxWidth>
    </>
  );
}

export default ContentPage;
